import styles from './style.module.scss';

export const FeedComments = ({
  comments,
  showAllComments,
  onShowAllComments,
  onNewCommentChange,
  newComment,
  onAddComment,
  commentLoading,
}) => {
  const visibleComments = showAllComments ? comments : comments.slice(0, 2);
  const hasMoreComments = comments.length > 2;

  return (
    <div className={styles.commentsSection}>
      {comments.length > 0 && (
        <>
          {hasMoreComments && !showAllComments && (
            <button
              type="button"
              className={styles.loadMoreComments}
              onClick={onShowAllComments}
            >
              Ver todos os {comments.length} comentários
            </button>
          )}

          <div className={styles.commentsList}>
            {visibleComments.map(comment => (
              <div
                key={comment.id}
                className={styles.comment}
              >
                <div className={styles.commentAuthor}>{comment.author}</div>
                <div className={styles.commentText}>{comment.text}</div>
              </div>
            ))}
          </div>
        </>
      )}

      <div className={styles.commentInputWrapper}>
        <textarea
          className={styles.commentInput}
          placeholder="Escreva um comentário..."
          value={newComment}
          onChange={e => onNewCommentChange(e.target.value)}
          rows="2"
        />
        <button
          type="button"
          className={styles.submitCommentButton}
          onClick={onAddComment}
          disabled={!newComment.trim() || commentLoading}
        >
          {commentLoading ? 'Enviando...' : 'Enviar'}
        </button>
      </div>
    </div>
  );
};
